import { render, staticRenderFns } from "./WorkIndex.vue?vue&type=template&id=fd3dcc8a"
import script from "./WorkIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkIndex.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WorkIndex.vue?vue&type=style&index=0&id=fd3dcc8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports